import {L} from "../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import {IPortalServices} from "../lt-ng/portal-services";

export interface IMetadataService {
    getMetadata(nodes: Item[]): ng.IPromise<any>;
}

export class NoLayerSelectedError extends Error {

}

export class MetadataService implements IMetadataService {
    public static $inject = ['$http', '$q', 'portalServices'];

    constructor(protected $http: ng.IHttpService, protected $q: ng.IQService, protected portalService: IPortalServices) {
    }

    getMetadata(nodes: Item[]): ng.IPromise<any> {
        const $http = this.$http;
        const url: string = `${this.portalService.baseUri()}/layer_meta_info/json`;

        const layerNames = L.tree.getLayerNames(nodes);
        if (!layerNames || !layerNames.length) {
            return this.$q.reject(new NoLayerSelectedError('no layers selected')); // nothing to display
        }
        return $http({
            method: 'GET',
            url: url,
            params: {
                layers: layerNames.join(',')
            },
            cache: true
        }).then((data: any) => {
            const response = data.data
                .response.sort((a, b) => layerNames.indexOf(a.layerName) - layerNames.indexOf(b.layerName));
            return response.map((o) => {
                return {
                    title: o['title'],
                    description: o.description,
                    externalLink: o.externalLink
                }
            });
        });
    }
}
